import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';

interface ValueProps {
  active: boolean;
}

export const Container = styled.section`
  background: ${({ theme }) => theme.searchInput.date.background};
  color: ${({ theme }) => theme.searchInput.date.label.color};
  box-shadow: ${({ theme }) => theme.searchInput.date.boxShadow};

  height: ${({ theme }) => theme.searchInput.date.height};
  max-width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.searchInput.date.padding};
  position: relative;
  border-radius: 8px;
  border: ${({ theme }) => theme.searchInput.date.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const Content = styled.button`
  flex: 1;
  cursor: pointer;
  background: none;
  text-align: left;
  margin-right: 8px;
  ${_ellipsis()};
`;

export const Label = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.searchInput.date.detail.top};

  font-size: ${({ theme }) => theme.searchInput.date.detail.fontSize};
  line-height: unset;
  color: ${({ theme }) => theme.searchInput.date.detail.color};
`;

export const Value = styled.span<ValueProps>`
  font-size: ${({ theme }) => theme.searchInput.date.label.fontSize};
  ${_ellipsis()};
  line-height: unset;
  color: ${({ theme, active }) =>
    active ? theme.searchInput.date.label.color : theme.searchInput.date.placeholder.label.color};
  font-weight: ${({ active }) => (active ? '600' : 'normal')};
  margin-top: ${({ theme }) => theme.searchInput.date.label.marginTop};
`;
